// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_pc-0";
export var buttonContainer = "_pc-3";
export var cancelButton = "_pc-4";
export var headerSection = "_pc-6";
export var headerTitle = "_pc-9";
export var messageSideLeft = "_pc-1";
export var messageSideRight = "_pc-2";
export var orderNumberContainer = "_pc-7";
export var orderNumberLabel = "_pc-8";
export var submitButton = "_pc-5";